import React from "react";
import { ReactComponent as CopyPageImage } from "../../images/copypage-image.svg";
import separator5 from "../../shapes/separator-5.svg";
import QuickLinksMenu from "../components/QuickLinksMenu";

export default function ContactSection() {
  return (
    <div className="section relative flex min-h-0 min-w-full flex-col items-center justify-start overflow-visible bg-black pt-6 pb-0 text-white">
      <div className="relative z-10 flex w-full min-w-0 justify-center overflow-x-auto px-4 pb-0 sm:px-10">
        <QuickLinksMenu
          className="hero-quick-menu hero-quick-menu--contact min-w-0 max-w-full"
          label="Contact links"
          secureLinks
        />
      </div>
      <div
        className="about-section-separator about-section-separator--below-about pointer-events-none z-10 mt-6 box-border w-full shrink-0 select-none lg:mt-8"
        style={{
          backgroundImage: `url(${separator5})`,
        }}
        aria-hidden
      />
      <div
        className="contact-footer-crt-field relative isolate w-full shrink-0 overflow-hidden pb-0"
        aria-hidden
      >
        <div className="contact-footer-scanline-fallback" aria-hidden />
        <div className="contact-footer-glitch-zone flex w-full max-w-full shrink-0 justify-end self-stretch pr-0 pb-0 pl-0 pointer-events-none">
          <div className="contact-footer-art-shell">
            <div className="hero-face-wrap contact-footer-face-wrap">
              <div className="hero-face-glitch">
                <div className="hero-face-glitch__channel hero-face-glitch__channel--cyan">
                  <CopyPageImage className="hero-face-glitch__base hero-face-svg contact-copypage-svg" />
                </div>
                <div className="hero-face-glitch__channel hero-face-glitch__channel--magenta">
                  <CopyPageImage className="hero-face-glitch__base hero-face-svg contact-copypage-svg" />
                </div>
                <CopyPageImage className="hero-face-glitch__base hero-face-svg contact-copypage-svg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
